/* eslint-disable max-len */
import { _initialState } from './_initialState';

import {
  digitalDataPushTestEvent,
  customProductPipLoadedEvent,
  pageLoadWithProductImpressionsEvent,
  addItemToStackEvent,
  removeItemsFromStackEvent,
  modalLinkClickEvent,
  zoomModalClickEvent,
  printStackSummaryEvent,
  quickViewModalLoadEvent,
  continueBuildingEvent,
  shareDesignEvent,
  quickViewSectionViewedEvent,
  quickViewPipClickThroughEvent,
  errorInteractionsEvent,
  promotionAccordionsEvent,
  calloutModalLinkClickEvent,
  calloutModalCloseEvent,
  changeCollectionEvent,
  preconfiguredLayoutLinkClickEvent,
  preconfiguredConfirmationModalEvent,
  trackProductCategorySelectEvent,
  trackProductSelectEvent,
  trackRemoveProductsEvent,
  trackZoomIconClickEvent,
  trackContinueBuildingWallStorageEvent,
} from './actions';

export const digitalDataStore = (set, get) => ({
  ..._initialState,
  testEvent: () => digitalDataPushTestEvent(set, get),
  trackCustomProductPipLoadedEvent: (
    partnerProductId = '325168962',
    productName,
    brand,
    logEventsToConsole,
    omnitureInfo,
    sendPaymentEstimatorImpressionToAnalytics,
    store,
    pageType
  ) => customProductPipLoadedEvent(
    set, get, partnerProductId,
    productName,
    brand,
    logEventsToConsole,
    omnitureInfo,
    sendPaymentEstimatorImpressionToAnalytics,
    store,
    pageType
  ),
  trackPageLoadWithProductImpressionsEvent: (productData, store, configurator, productInfo) => pageLoadWithProductImpressionsEvent(set, get, productData, store, configurator, productInfo),
  trackAddItemToStackEvent: (sku, basePrice) => addItemToStackEvent(set, get, sku, basePrice),
  trackRemoveItemsFromStackEvent: (target, productArray) => removeItemsFromStackEvent(set, get, target, productArray),
  trackModalLinkClickEvent: (feature, name, modalTrackingOptions) => modalLinkClickEvent(set, get, feature, name, modalTrackingOptions),
  trackCalloutModalLinkClickEvent: (feature, callout) => calloutModalLinkClickEvent(set, get, feature, callout),
  trackCalloutModalCloseEvent: (feature, callout) => calloutModalCloseEvent(set, get, feature, callout),
  trackZoomModalClickEvent: () => zoomModalClickEvent(set, get),
  trackPrintStackSummaryEvent: () => printStackSummaryEvent(set, get),
  trackQuickViewModalLoadEvent: () => quickViewModalLoadEvent(set, get),
  trackContinueBuildingEvent: (eventData) => continueBuildingEvent(set, get, eventData),
  trackContinueBuildingWallStorageEvent: (eventData) => trackContinueBuildingWallStorageEvent(set, get, eventData),
  trackShareDesignEvent: (target, currentUrl) => shareDesignEvent(set, get, target, currentUrl),
  trackQuickViewSectionViewedEvent: (title) => quickViewSectionViewedEvent(set, get, title),
  trackQuickViewPipClickThroughEvent: (payload) => quickViewPipClickThroughEvent(set, get, payload),
  trackQuickViewPipClickThroughEven: (payload) => quickViewPipClickThroughEvent(set, get, payload),
  trackErrorInteractionsEvent: (errorObject, primaryCategory, eventName) => errorInteractionsEvent(set, get, errorObject, primaryCategory, eventName),
  trackPromotionAccordionsEvent: (target) => promotionAccordionsEvent(set, get, target),
  trackChangeCollectionEvent: () => changeCollectionEvent(set, get),
  trackPreconfiguredLayoutLinkClickEvent: (templateName) => preconfiguredLayoutLinkClickEvent(set, get, templateName),
  trackPreconfiguredConfirmationModalEvent: () => preconfiguredConfirmationModalEvent(set, get),
  trackProductCategorySelectEvent: (payload) => trackProductCategorySelectEvent(set, get, payload),
  trackProductSelectEvent: (payload) => trackProductSelectEvent(set, get, payload),
  trackRemoveProductsEvent: (payload) => trackRemoveProductsEvent(set, get, payload),
  trackZoomIconClickEvent: (payload) => trackZoomIconClickEvent(set, get, payload),
});
